import Vuex, { StoreOptions, Commit } from 'vuex';
import Vue from 'vue';
import { auth } from '@/features/account/store/auth';
import { company } from '@/features/companies/store/company';
import { store } from '@/features/stores/store/store';
import { salesReceipt } from '@/features/salesreceipts/store/salesReceipt';
import { user } from '@/features/account/store/user';
import { admin } from '@/features/admin/store/admin';

Vue.use(Vuex);

export interface IVuexState {
  version: string;
}

const vuexStore: StoreOptions<IVuexState> = {
  state: {
    version: '1.0',
  },
  mutations: {},
  actions: {
    reset: ({ commit }: { commit: Commit }) => {
      commit('auth/reset');
      commit('company/reset');
      commit('salesReceipt/reset');
      commit('store/reset');
      commit('user/reset');
      commit('admin/reset');
    },
  },
  modules: {
    user,
    auth,
    company,
    store,
    salesReceipt,
    admin,
  },
};

export default new Vuex.Store<IVuexState>(vuexStore);

export function findWithAttr(array: any[], attr: string, value: any): number {
  for (let i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
}

export function getFileName(response: any, status: any, xhr: any) {
  let filename = '';
  const disposition = response.request.getResponseHeader('Content-Disposition');
  if (disposition && disposition.indexOf('attachment') !== -1) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
      return filename;
    }
  }
  return '';
}
